import "../Styles/Footer.css";
import { Link } from "react-router-dom";
import GraniteLogo from "../Assets/SNS2.png";

function Footer() {
  return (
    <footer className="footer-section" id="contactus">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-logo-container">
            <Link to="/" className="footer-brand">
              <img
                src={GraniteLogo}
                alt="SNS Granite Factory Logo"
                className="footer-logo"
              />
              <span className="footer-title">SNS GRANITE FACTORY</span>
            </Link>
          </div>
          <p className="footer-description">
            Explore a premium selection of natural granite and marble products
            crafted to perfection. We provide customized cutting, polishing,
            and finishing solutions for commercial and residential projects.
            Our commitment to quality and precision ensures enduring elegance
            in every stone we deliver.
          </p>
        </div>

        <div className="footer-middle" id="contact">
          <p className="contact-title">Contact Us</p>

          <ul className="contact-list">

            <li>
              <p><b>Proprietor:</b> Mr. V. N. Balaji</p>
            </li>

            <li>
              <span className="icon">📧</span>
              <a href="mailto:vishnugranitt@gmail.com">vishnugranitt@gmail.com</a>
            </li>

            <li>
              <p>
                <span className="icon">📞</span>
                <a href="tel:+916379193694">+91 63791 93694</a>
              </p>
            </li>

            <li>
              <p>
                <span className="icon">📞</span>
                <a href="tel:+919944085813">+91 99440 85813</a>
              </p>
            </li>

            <li>
              <p><b>GST:</b> 33AQCPB5332L2Z5</p>
            </li>

            <li>
              <span className="address">
                79L, First Floor, 8th Cross, Jakkappan Nagar, Krishnagiri, Tamil Nadu – 635001
              </span>
            </li>
          </ul>
        </div>
        <div className="footer-right">
          <p className="map-title">Our Location</p>
          <div className="map-container">
            <iframe
              title="SNS Granite Factory Location"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3894.925983966281!2d78.21065717506889!3d12.521062287754441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDMxJzE1LjgiTiA3OMKwMTInNDcuNiJF!5e0!3m2!1sen!2sin!4v1763043864909!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>©2025 SNS Granite Factory. All rights reserved.</p>
      </div>
    </footer>
  );
}
export default Footer;